import styled from 'styled-components';

const Loading = ({ isContent, isList }: any) => {
  return (
    <LoadingContainer
      style={
        isContent && {
          position: 'absolute' as 'absolute',
          backgroundColor: '#FFFFFF',
          top: 244,
          zIndex: 100,
        }
      }
    >
      <img
        src="/assets/images/icon/loading_w.gif"
        style={{ width: '56px', height: '56px' }}
        alt=""
      />
      <LoadingText>로딩 중 입니다.</LoadingText>
    </LoadingContainer>
  );
};

export default Loading;

const LoadingContainer = styled.div`
  width: 100%;
  /* height: 100dvh; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  /* z-index: 100; */
  padding: 160px 0;
`;

const LoadingText = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.9px;
  color: rgba(23, 30, 38, 0.78);
`;
